module.exports = __webpack_public_path__ + "static/media/valentin_barco.8a9c81b0.jpg";